export default {
    data() {
        return {
            blogId: '',
            blog: {},
            dialogShow: false,//弹框
            commentParams: {
                commentAuthor: '',
                commentAuthorEmail: '',
                commentContent: '',
                commentParent: 0,
                commentType: '0',
                userId: '',
                commentAuthorUrl: '',
                ancestor: 0,
                commentAuthorPhoto: '',
                replyTo: '',
            }, //评论的参数
            allComments: [],//所有的评论数据
            current: 1,//当前页
            typeMap: {
                0: "原创",
                1: "转载",
                2: "翻译",
            },
        }
    },
    created() {
        this.blogId = this.$route.query.blogId;
        this.reading();
        this.initData();
    },
    methods: {

        //评论输入
        contentEnter(e) {
            this.commentParams.commentContent = e.target.innerHTML.trim();
        },

        // 获取随笔详情
        async initData() {
            const { API, $request, blogId } = this;
            const url = API.getBlogInfo;
            const { data: res } = await $request(url, 'get', {
                blogId,
            })
            const blog = res.data || {};
            if (res.code == 200 && !res.data) {
                alert("该随笔已丢失,如有疑问请联系管理员");
                this.$router.replace("/index");
                return;
            }

            if (res.code == 200) {
                for (const item of blog.comments) {
                    item.childComment = this.flattenChild(item.childComment);
                }

                const allComments = [...blog.comments];
                blog.comments = allComments.slice(0, 5);
                this.allComments = allComments;
                this.blog = blog;
            }
        },

        //加载更多评论
        loadmore() {
            if (this.blog.comments.length >= this.allComments.length) return;
            this.current++;
            const start = (this.current - 1) * 5;
            const end = start + 5;

            const list = this.allComments.slice(start, end);
            this.blog.comments = this.blog.comments.concat([...list]);
        },

        // 添加评论
        async comment() {
            const { API, $request, blogId, commentParams, $utils } = this;
            if (!commentParams.commentAuthor) return alert("昵称和邮箱不能为空哦!");
            if (!commentParams.commentAuthorEmail) return alert("昵称和邮箱不能为空哦!");
            if (!$utils.isEmail(commentParams.commentAuthorEmail)) return alert("请输入正确的邮箱!");
            if (!commentParams.commentContent) return alert("请输入评论内容");
            const url = API.addComment;
            const params = { blogId, ...commentParams };

            const { data: res } = await $request(url, 'post', params);
            if (res.code == 200) {
                this.hide();
                alert("感谢评论,待管理员审核通过即可展示!");
                return;
            }
            alert(res.msg);
        },

        // 点赞
        async like() {
            const { API, $request, blogId } = this;
            const url = API.like;
            await $request(url, 'post', {
                blogId,
            })
            this.blog.likeCount += 1;
        },

        //增加阅读
        async reading() {
            const { API, $request, blogId } = this;
            const url = API.reading;
            await $request(url, 'post', {
                blogId
            })
        },

        //显示弹框item是评论者的信息，type是回复的人是楼主还是其他评论者
        showPopup(item, type) {
            if (type === 'up') { //如果是楼主
                this.commentParams.ancestor = item.commentId;
            }

            if (type === 'floor') {//如果是其他评论者
                this.commentParams.ancestor = item.ancestor;
            }

            this.commentParams.commentParent = item.commentId || 0; //上级就是
            this.commentParams.replyTo = item.commentAuthor || "";
            const random = Math.floor(Math.random() * 4) + 1;
            const img = `/blog/images/${random}.jpg`;
            this.commentParams.commentAuthorPhoto = img;
            this.dialogShow = true;
        },

        //取消弹框
        hide() {
            this.dialogShow = false;
            this.commentParams = {
                commentAuthor: '',
                commentAuthorEmail: '',
                commentContent: '',
                commentParent: 0,
                commentType: '0',
                userId: '',
                commentAuthorUrl: '',
                ancestor: 0,
                commentAuthorPhoto: '',
                replyTo: '',
            }
            this.$refs['contentBox'].innerHTML = "";
        },

        //递归展开子评论 实现只有两层
        flattenChild(arr) {
            if (!arr || !Array.isArray(arr)) return;
            const result = [];

            function flatten(item) {
                if (item.childComment && item.childComment.length > 0) {
                    item.childComment.forEach(function (child) {
                        flatten(child);
                    });
                    item.childComment = null;
                    result.push(item)
                } else {
                    result.push(item);
                }
            }

            arr.forEach(function (item) {
                flatten(item);
            });

            result.sort((a, b) => {
                return a.commentTime > b.commentTime ? 1 : -1;
            });
            return result;
        },

        //获取类型颜色
        getTypeClass(type) {
            let className = "";
            switch (type) {
                case "0":
                    className = "blue";
                    break;
                case "1":
                    className = "green";
                    break;
                case "2":
                    className = "yellow";
                    break;
            }
            return className;
        },
    },
}